import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import testGuideContent from 'docs/TEST_GUIDE.md';
import { remCss } from 'src/helpers';

const TestGuide = () => {
  return (
    <div
      style={{
        maxWidth: 900,
        margin: '0 auto',
        padding: `${remCss(40)}px ${remCss(24)}px`,
        fontFamily: 'inherit',
        lineHeight: 1.7,
        color: '#222'
      }}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{testGuideContent}</ReactMarkdown>
    </div>
  );
};

export default TestGuide;
